import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { prospectPath, prospectPages } from '../../ProspectRouter';
import { PropertyContext, tourSignupPath, TourPage } from '../TourRouter';

const GuestCardLoadFailureDisplay = (props: { error?: string }) => {
    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    return (
        <div>
            <FormValidationDisplay errorMessage={props.error} />
            <p>
                We didn't find the associated guest card. If you already filled it out, you can find
                it on the <Link to={prospectPath(prospectPages.tours)}>My Tours Page</Link>.
            </p>
            <p>
                If you'd like to start a new signup for {property.name}, you can do by submitting a
                new <Link to={tourSignupPath(property.slug)(TourPage.GuestCard)}>Guest Card</Link>.
            </p>
        </div>
    );
};

export default GuestCardLoadFailureDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/display/GuestCardLoadFailureDisplay.tsx